
// Exportar servicio principal
export { EphemeralTokenService } from './ephemeral-token.service';

// Exportar interceptor (para registrar en app.module.ts)
export { EphemeralTokenInterceptor } from './ephemeral-token.interceptor';

// Exportar configuración y helpers
export {
  EPHEMERAL_TOKEN_CONFIG,
  requiresEphemeralToken,
  getSecurityEndpointUrl
} from './ephemeral-token.config';

// Exportar interfaces
export {
  EphemeralTokenResponse,
  TokenState,
  EphemeralTokenConfig
} from './ephemeral-token.interface';
